module.exports = __webpack_public_path__ + "img/merchant_empty.ed7dc234.png";